var React = require('react');

function X (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"16","cy":"16","r":"16","fill":"#6677FB","key":0}),React.createElement("g",{"clipPath":"url(#a)","key":1},React.createElement("path",{"fill":"#fff","d":"M17.332 14.925 22.544 9h-1.235l-4.526 5.145L13.17 9H9l5.466 7.78L9 22.992h1.235l4.78-5.433 3.816 5.433H23l-5.668-8.068Zm-1.692 1.923-.554-.775L10.68 9.91h1.897l3.556 4.975.554.775 4.622 6.466h-1.897l-3.772-5.277Z"})),React.createElement("defs",{"key":2},React.createElement("clipPath",{"id":"a"},React.createElement("path",{"fill":"#fff","d":"M9 9h14v14H9z"})))]);
}

X.defaultProps = {"width":"32","height":"32","fill":"none"};

module.exports = X;

X.default = X;
